export default [
  "2 years",
  "5 years",
  "10 years",
  "20 years",
  "25 years",
  "30 years",
  "50 years",
  "≤50 years",
  "100 years",
  "200 years",
  "250 years",
  "300 years",
  "500 years",
  "> 500 years (US)",
  "1000 years",
  "≥1000 years",
  "Waterbody",
  "Outside",
  "No Data",
  "No Observation"
];
